module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-part sgc-3",
    attrs: {
      "xml:lang": "fr-FR",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Part1"
    }
  }, [_vm._v("PART 1: THE POWER OF CULTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1"
    }
  }, [_vm._v("1 What Is Missional Culture and Why Does It Matter?")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap2"
    }
  }, [_vm._v("2 How Culture Works")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 What’s Going On in the Culture of the Church You Serve")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Polycentric Leadership and Missional Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-part sgc-3",
    attrs: {
      "xml:lang": "fr-FR",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2: A LEADERSHIP IMAGINATION THAT SHAPES MISSIONAL CULTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Facing Today's Challenges")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Hearing the Story")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Deepening Theological Roots")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Embracing Emotional Health")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Relinquishing the Need to Control")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-part sgc-3",
    attrs: {
      "xml:lang": "fr-FR",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 3: THE FIVE CULTURE CREATORS")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Jesus the Archetypical Culture Creator")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Apostles")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap11#heading_id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dream Awakeners")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Prophets")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap12#heading_id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heart Revealers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Evangelists")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap13#heading_id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Story Tellers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Pastors")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap14#heading_id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soul Healers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Teachers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap15#heading_id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light Givers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-part sgc-3",
    attrs: {
      "xml:lang": "fr-FR",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 4: EMBODYING A MISSIONAL CULTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 The Cultural Web and the Neighborhood Church")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Cultivating Missional Environments")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Cultivating in Equipping Ethos")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Polycentric Leadership at Work")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Appendix2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Appendix3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Endorsements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endorsements")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0